import React from 'react'
import { ErrorContent } from '@bbl-digital/snorre-v2'
import { ERROR_NO_PAGE_FOUND } from 'shared/constants/errorMessages'
import { Wrapper as ErrorWrapper } from './styles'

const NoPageError: React.FC = () => {
  return <ErrorContent size="xl" text={ERROR_NO_PAGE_FOUND} />
}

export { ErrorWrapper, NoPageError }
export default NoPageError
